<script setup lang="ts">
defineProps<{
  isBlurred: false
}>()
</script>

<template>
  <div class="salary-card border-border rounded-md border">
    <div class="salary-head text-base">
      <div class="salary-eyebrow">Salario bruto anual · 2026</div>
      <div
        class="text-primary mt-4 text-5xl font-bold"
        :class="{
          'user-select-none pointer-events-none blur-sm transition-all duration-300':
            isBlurred,
        }"
      >
        30.000,00<span class="text-2xl">€</span>
      </div>
    </div>

    <div class="delta-stack">
      <span class="delta-pill">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          data-lucide="trending-up"
          class="lucide lucide-trending-up"
        >
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
          <polyline points="16 7 22 7 22 13"></polyline>
        </svg>
        <span
          :class="{
            'user-select-none pointer-events-none blur-sm transition-all duration-300':
              isBlurred,
          }"
          >+30.2%</span
        >
        vs. 2021
      </span>
    </div>

    <div class="chart">
      <div class="chart-grid" aria-hidden="true">
        <div class="gline">
          <span
            :class="{
              'user-select-none pointer-events-none blur-sm transition-all duration-300':
                isBlurred,
            }"
            >30k €</span
          >
        </div>
        <div class="gline">
          <span
            :class="{
              'user-select-none pointer-events-none blur-sm transition-all duration-300':
                isBlurred,
            }"
            >27k €</span
          >
        </div>
        <div class="gline">
          <span
            :class="{
              'user-select-none pointer-events-none blur-sm transition-all duration-300':
                isBlurred,
            }"
            >24k €</span
          >
        </div>
      </div>
      <div class="chart-bars">
        <div class="sbar previous">
          <div class="stem" style="height: 28.8%">
            <span class="stem-label"
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >23.045€</span
              ></span
            >
          </div>
          <span class="year">Julio 2021</span>
        </div>
        <div class="sbar previous">
          <div class="stem" style="height: 50.6%">
            <span class="stem-label"
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
              >
                25.165€
              </span>
            </span>
            <span class="delta-tag"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                data-lucide="arrow-up"
                class="lucide lucide-arrow-up"
              >
                <path d="m5 12 7-7 7 7"></path>
                <path d="M12 19V5"></path></svg
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >9.2%</span
              ></span
            >
          </div>
          <span class="year">Julio 2022</span>
        </div>
        <div class="sbar previous">
          <div class="stem" style="height: 66%">
            <span class="stem-label"
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >26.675€</span
              ></span
            >
            <span class="delta-tag"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                data-lucide="arrow-up"
                class="lucide lucide-arrow-up"
              >
                <path d="m5 12 7-7 7 7"></path>
                <path d="M12 19V5"></path></svg
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >6.0%</span
              ></span
            >
          </div>
          <span class="year">Julio 2023</span>
        </div>
        <div class="sbar previous">
          <div class="stem" style="height: 84.6%">
            <span class="stem-label"
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >28.490€</span
              ></span
            >
            <span class="delta-tag"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                data-lucide="arrow-up"
                class="lucide lucide-arrow-up"
              >
                <path d="m5 12 7-7 7 7"></path>
                <path d="M12 19V5"></path></svg
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >6.8%</span
              ></span
            >
          </div>
          <span class="year">Julio 2024</span>
        </div>
        <div class="sbar current">
          <div class="stem" style="height: 100%">
            <span class="stem-label"
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >30.000€</span
              ></span
            >
            <span class="delta-tag"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                data-lucide="arrow-up"
                class="lucide lucide-arrow-up"
              >
                <path d="m5 12 7-7 7 7"></path>
                <path d="M12 19V5"></path></svg
              ><span
                :class="{
                  'user-select-none pointer-events-none blur-sm transition-all duration-300':
                    isBlurred,
                }"
                >5.3%</span
              ></span
            >
          </div>
          <span class="year">Julio 2025</span>
        </div>
      </div>
    </div>

    <div>
      <p class="text-muted-foreground">
        *Incrementos aplicados en el mes de Julio
      </p>
    </div>
  </div>
</template>

<style scoped>
.salary-card {
  padding: 18px;
  background: #fff;
  margin-top: 14px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px 28px;
  align-items: start;
}
.salary-head {
  grid-column: 1 / 2;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.salary-eyebrow {
  color: var(--muted-foreground);
}
.salary-current {
  font-family: var(--font-display);
  font-size: 40px;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin-top: 6px;
  font-variant-numeric: tabular-nums;
}
.salary-current .cur {
  font-weight: 500;
  color: var(--muted-foreground);
  margin-left: 4px;
}

.delta-stack {
  grid-column: 2 / 3;
  grid-row: 1 / 3;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  min-width: 220px;
}
.delta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 999px;
  background: #e8f7ee;
  color: #0f7a3c;
  font-weight: 600;
  font-size: 13.5px;
  line-height: 1;
  letter-spacing: -0.005em;
  font-variant-numeric: tabular-nums;
}
.delta-pill [data-lucide] {
  width: 14px;
  height: 14px;
  stroke-width: 2.2;
}
.delta-pill.negative {
  background: #fdecec;
  color: #b1361f;
}
.delta-meta {
  color: var(--muted-foreground);
  font-size: 12.5px;
  line-height: 1.4;
  max-width: 26ch;
  text-align: right;
}

.chart {
  grid-column: 1 / 3;
  margin-top: 6px;
  position: relative;
}
.chart-grid {
  position: absolute;
  inset: 0 0 36px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
}
.chart-grid .gline {
  position: relative;
  height: 1px;
  background: var(--border);
}
.chart-grid .gline span {
  position: absolute;
  left: 0;
  top: -7px;
  font-size: 11px;
  color: var(--muted-foreground);
  background: #fff;
  padding-right: 6px;
  font-variant-numeric: tabular-nums;
}
.chart-bars {
  position: relative;
  height: 240px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 18px;
  padding: 40px 36px 36px 36px;
}
.sbar {
  position: relative;
  align-self: end;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
}
.sbar .stem {
  width: 100%;
  max-width: 64px;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(
    180deg,
    color-mix(in oklab, var(--primary) 100%, transparent) 0%,
    color-mix(in oklab, var(--primary) 80%, transparent) 100%
  );
  position: relative;
}
.sbar.previous .stem {
  background: linear-gradient(180deg, #d6dbf0 0%, #c7cde5 100%);
}
.sbar.current .stem {
  box-shadow: 0 8px 22px -10px
    color-mix(in oklab, var(--primary) 70%, transparent);
}
.sbar .stem-label {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 6px);
  transform: translateX(-50%);
  font-weight: 600;
  font-size: 13px;
  background: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid var(--border);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  z-index: 1;
}
.sbar.current .stem-label {
  background: var(--primary);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 4px 12px -4px
    color-mix(in oklab, var(--primary) 60%, transparent);
}
.sbar .delta-tag {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 40px);
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #e8f7ee;
  color: #0f7a3c;
  font-weight: 600;
  font-size: 11px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  z-index: 2;
}
.sbar .delta-tag.negative {
  background: #fdecec;
  color: #b1361f;
}
.sbar .delta-tag [data-lucide] {
  width: 10px;
  height: 10px;
  stroke-width: 2.4;
}
.sbar .year {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--muted-foreground);
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.04em;
}
.sbar.current .year {
  color: var(--primary);
  font-weight: 600;
}

@keyframes grow {
  from {
    transform: scaleY(0);
  }
  to {
    transform: scaleY(1);
  }
}

.salary-footer {
  grid-column: 1 / 3;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 12px;
  padding-top: 18px;
  border-top: 1px solid var(--border);
}
.stat-label {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--muted-foreground);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.stat-value {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -0.01em;
  margin-top: 6px;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}
.stat-sub {
  color: var(--muted-foreground);
  font-size: 12.5px;
  margin-top: 4px;
}

@media (max-width: 1100px) {
  .salary-card {
    grid-template-columns: 1fr;
  }
  .delta-stack {
    grid-row: auto;
    grid-column: 1 / 2;
    align-items: flex-start;
  }
  .delta-meta {
    text-align: left;
  }
  .salary-footer {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}
</style>
